// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1e9a156","239":"b57c3c0f","453":"78b0b479","455":"eec15dfe"}[chunkId] + ".chunk.js";
};